export const HOMEPAGE = "/~devikac";

export const HOME_PAGE_ROUTE = HOMEPAGE + "/";
export const MEMBERS_PAGE_ROUTE = HOMEPAGE + "/lab";
export const PUB_PAGE_ROUTE = HOMEPAGE + "/publications";
export const NEWS_PAGE_ROUTE = HOMEPAGE + "/news";
export const CONTACT_US_PAGE_ROUTE = HOMEPAGE + "/contact";
export const PHOTOS_PAGE_ROUTE = HOMEPAGE + "/photos";
